<template>
  <div class="mb-10">
    <v-navigation-drawer v-model="sideNav" absolute temporary>
      <v-list-item>
        <v-list-item-avatar>
          <v-img>
            <!--user image here-->
          </v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <!--user's name here-->
            {{profile.fullName}}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          router-link
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon color="red" v-if="isOverDue">{{ item.postIcon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn block @click="logout()">
            Logout
          </v-btn>
        </div>
      </template>

    </v-navigation-drawer>
    <v-app-bar dense fixed>
      <v-icon class="hidden-sm-and-up navicon" @click="sideNav = !sideNav"
        >view_headline</v-icon
      >
      <v-toolbar-title class="mr-6" router-link to="/welcome"
        >ReminDo</v-toolbar-title
      >
      <v-toolbar-items
        v-for="item in items"
        :key="item.title"
        :class="item.class"
        class="hidden-xs-only"
      >
        <v-btn depressed router-link :to="item.link">
          <v-icon left>{{ item.icon }}</v-icon>
          {{ item.title }}
          <v-icon right color="red" v-if="isOverDue">{{
            item.postIcon
          }}</v-icon>
        </v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-icon
        left
        color="red"
        class="hidden-sm-and-up"
        v-if="isOverDue"
        @click="toOverDue"
        >warning</v-icon
      >
      <v-toolbar-items>
        <v-btn depressed color="#15c39a" router-link to="/new">
          <v-icon left>alarm_add</v-icon>Add a Task
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn depressed v-bind="attrs" v-on="on" class="hidden-xs-only">
              <v-icon left>person</v-icon>Profile
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-item>
              <v-btn
                depressed
                color="white"
                v-bind="attrs"
                v-on="on"
                to="/settings"
                class="hidden-xs-only"
              >
                <v-icon left>settings</v-icon>Setting
              </v-btn>
            </v-list-item> -->
            <v-list-item>
              <v-btn
                depressed
                color="white"
                v-bind="attrs"
                v-on="on"
                @click="logout()"
                class="hidden-xs-only"
              >
                <v-icon left>logout</v-icon>Logout
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sideNav: false,
      time: null,
      dialog: false,
      items: [
        { title: "Upcoming", icon: "event_note", link: "/agenda/upcoming" },
        {
          title: "Over Due",
          icon: "event_busy",
          link: "/agenda/overdue",
          postIcon: "warning"
        },
        { title: "Completed", icon: "event_available", link: "/agenda/completed" },
        // { title: "Setting", icon: "settings", link: "/settings", class:'hidden-sm-and-up' }
      ]
    };
  },
  methods: {
    logout() {
      this.$createDatabase("auth", "auth", this.$dbUrl);
      this.$db.auth.logout().finally(() => {
        this.$store.dispatch("saveUser", null);
        return this.$router.push("/login");
      });
    },
    toOverDue() {
      this.$router.push("/agenda/overdue");
    }
  },
  computed: {
    isOverDue() {
      return this.$store.getters.checkOverDue;
    }
  }
};
</script>

<style>
.navicon {
  margin-left: -8px;
}
</style>
